import React from 'react';

import { Placeholder } from './placeholder';

export const Paragraph = ({
  children,
  ...other
}: {
  children: React.ReactNode;
}) => (
  <div className="Placeholder Value">
    <Placeholder loading={true} {...other}>
      {children}
    </Placeholder>
  </div>
);
